<template>
  <a-card :body-style="{ padding: '24px 32px' }" :bordered="false">
    <a-form @submit="handleSubmit" :form="form">
      <a-form-item label="课程分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="[
          'cate_id',
          {
            rules: [{ required: true, message: '请选择课程分类' }],
            initialValue: info.cate_id
          }
        ]" placeholder="选择课程分类">
          <a-select-option v-for="option in category" :key="option.id" :value="option.id">{{ option.title }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="[
          'title',
          {
            rules: [{ required: true, message: '名称不能为空' }],
            initialValue: info.title
          },
        ]" placeholder="请输入分类名称" />
      </a-form-item>
      <a-form-item label="最低单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="[
          'price_min',
          {
            initialValue: info.price_min
          },
        ]" placeholder="请输入最低价(/小时)" />
      </a-form-item>
      <a-form-item label="最高单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="[
          'price_max',
          {
            initialValue: info.price_max
          },
        ]" placeholder="请输入最高价(/小时)" />
      </a-form-item>
      <a-form-item label="描述" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea rows="5" placeholder="请输入分类描述信息" v-decorator="[
          'notes',
          {
            initialValue: info.notes
          }
        ]" />
      </a-form-item>
      <a-form-item :wrapperCol="{ span: 24 }" style="text-align: center">
        <a-button htmlType="submit" :loading="submitLoading" type="primary">提交</a-button>
        <a-button style="margin-left: 8px" @click="routerback">返回</a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import { courseInfo, courseCreate, courseSave, courseCategory } from '@/api/course'

export default {
  name: 'EditCategory',
  data() {
    return {
      description: '课程编辑添加',
      value: 1,
      fontStyle: {
        fontWeight: 1000
      },
      labelCol: {
        lg: { span: 7 },
        sm: { span: 7 }
      },
      wrapperCol: {
        lg: { span: 10 },
        sm: { span: 17 }
      },
      customLabelCol: {
        lg: { span: 4 },
        sm: { span: 7 }
      },
      customWrapperCol: {
        lg: { span: 18 },
        sm: { span: 17 }
      },
      queryData: {},
      info: {},
      category: {},
      pageType: 'add', // 当前页面是新增(add),还是修改(edit)

      // form
      form: this.$form.createForm(this),
      submitLoading: false
    }
  },
  created() {
    const id = this.$route.query.id
    this.queryData.id = id
    if (id !== undefined) {
      this.pageType = 'edit'
      this.loadInfo(id)
    } else {
      this.loadCategory(id)
    }
  },
  methods: {
    loadInfo(id) {
      new Promise((resolve, reject) => {
        courseInfo({ 'id': id }).then(response => {
          if (response.status === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
      }).then(res => {
        this.info = res.data.info
        this.category = res.data.category
      }).catch(error => {
        this.$notification.error({
          message: '错误',
          description: error.message
        })
        // 跳转回
        setTimeout(() => {
          this.$router.back(-1)
        }, 2000)
      })
    },
    loadCategory() {
      new Promise((resolve, reject) => {
        courseCategory().then(response => {
          if (response.status === 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
      }).then(res => {
        this.category = res.data
      }).catch(error => {
        this.$notification.error({
          message: error.status,
          description: error.message,
          duration: 4
        })
      })
    },
    // handler
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.pageType === 'edit') {
            new Promise((resolve, reject) => {
              this.submitLoading = true
              values.id = this.queryData.id
              courseSave(values).then(response => {
                if (response.status === 'success') {
                  resolve(response)
                } else {
                  reject(response)
                }
              })
            }).then(res => {
              this.$notification.success({
                message: res.status,
                description: res.message
              })
              // 跳转回列表页面
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }).catch(error => {
              this.$notification.error({
                message: '错误',
                description: error.message
              })
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            // 新增
            new Promise((resolve, reject) => {
              this.submitLoading = true
              courseCreate(values).then(response => {
                if (response.status === 'success') {
                  resolve(response)
                } else {
                  reject(response)
                }
              })
            }).then(res => {
              this.$notification.success({
                message: res.status,
                description: res.message
              })
              // 跳转回列表
              setTimeout(() => {
                this.$router.back(-1)
              }, 2000)
            }).catch(error => {
              this.$notification.error({
                message: '错误',
                description: error.message
              })
            }).finally(() => {
              this.submitLoading = false
            })
          }
        }
      })
    },
    routerback: function () {
      this.$router.back(-1)
    }
  }
}
</script>
